<template>
    <v-card-text 
        v-if="content.type === 'text'"
        :class="'font-weight-' + (content.fontWeight ? content.fontWeight : 'light')"
        v-html="content.text"
    />
    <div
        v-else-if="content.type === 'video_embedded'"
        class="px-4"
    >
        <video-container :aspect_ratio="content.aspect_ratio">
            <iframe
                :src="content.url"
                frameborder="0"
            />
        </video-container>
    </div>
    <WebPImage
        v-else-if="content.type === 'image'" 
        :class="content.customClassName" 
        :src-without-file-type="content.src" 
        :available-file-types="content.fileTypes" 
        :max-height="content.maxHeight ? content.maxHeight : ''" 
        :max-width="content.maxWidth ? content.maxWidth : ''" 
        :aspect-ratio="content.aspectRatio ? content.aspectRatio : 1"
        :position="content.position"
        :no-auto-sizing="content.autoSize ? !content.autoSize : true"
        :contain="content.contain ? content.contain : false"
    />
    <v-card-actions v-else-if="content.type === 'actions'">
        <template 
            v-for="(button, index) in content.buttons"
        >
            <v-btn
                v-if="button.type === 'external'"
                :key="index"
                :color="$vuetify.theme.themes.light.primary"
                text
                target="_blank"
                :href="button.url"
            >
                {{ button.text }}
            </v-btn>
            <v-btn
                v-else
                :key="index"
                :color="$vuetify.theme.themes.light.primary"
                text
                @click="$router.push(button.route)"
            >
                {{ button.text }}
            </v-btn>
        </template>
    </v-card-actions>
    <v-divider v-else-if="content.type === 'divider'" />
    <v-card-text v-else-if="content.type === 'unordered_list'">
        <ul>
            <li
                v-for="item in content.listItems"
                :key="item"
                class="text-left"
            >
                {{ item.text }}
            </li>
        </ul>
    </v-card-text>
    <div
        v-else-if="content.type === 'spacer'"
        :style="{height: content.height + 'rem'}"
    />
    <div v-else-if="content.type === 'carousel_card'">
        <AZCarousel :items="content.images" />
    </div>
</template>

<script>
import VideoContainer from "@/components/VideoContainer.vue";
import WebPImage from "@/components/WebPImage.vue";
import AZCarousel from "@/components/AZCarousel.vue";

export default {
    components: {
        VideoContainer,
        WebPImage,
        AZCarousel
    },
    props: ["content", "actions"]
}
</script>